import { handleActions } from "redux-actions";
import { setDraggedConverter } from "../actions/actions";

export default handleActions(
  {
    [setDraggedConverter]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
